import { Contact } from './Contact';
import { Prospect } from './prospect';
import { Staff } from './Staff';
import { Pjoint } from './Pjoint';
import { Client } from './exhibitor';


export interface DialogData {
    invoice: Facture;
}


export class Facture {
    idfacture: Number;
    numeroFiche: string;
    numeroFicheContrat: string;
    devise: string;
    datefacture: Date;
    dateEcheance: Date;
    dateenvoicontrat: Date;
    tva: boolean;
    numerofacture: number;
    anne: number;
    aclasser: boolean;
    finance: boolean;
    timbre: boolean;
    prospectprospectId: Prospect;
    client: Client;
    contactcontactId: Contact;
    sociFactSociFactId: Socifact;
    utilisateurs: Staff;
    montantht: number;
    montantotal: number;
    montantremise: number;
    montantttc: number;
    montanttva: number;
    groupeFinance: string;
    typePaiement: string;
    type: string;

    observationFinance: string;
    observation: string;
    encaisser: number;
    percent: number;
    reste: number;
    status: string;
    annuler: boolean;

}
export class Socifact {
    sociFactId: number;
    designation: string;
    raisonSocial: string;
    deviseId: Devise;
    teteSrc: string;
    teteSignature: string;
    banque: string;
    adresse: string;
    adresseBanque: string;
    agence: string;
    gerant: string;
    iban: string;
    invisible: string;
    numero: string;
    swift: string;
    ville: string;
    tete:string;
    teteEditionBlob:any;
    signature:string;
    textVisa:string;
    textDouane:string;
    tva:number;


}
export class Produit {
    produitId: number;
    designation: string;
    designationAn: string;

    specifique: boolean;
    delegate: boolean;
    publicite: boolean;
    prixDol: number;
    prixDzd: number;
    prixEuro: number;
}
export class Facturedetail {
    idfacturedetail: Number;
    designation: string;
    produit: Produit;
    prixunit: number;
    quantite: number;
    remise: number;
    remisep: number;
    stotal: number;
    idfacture: Facture;
    edit: boolean;

    stand: string;

    numeroFiche: string;
    raisonSocial: string;


}
export class Devise {
    deviseId: Number;
    designation: string;
    symbol: string;

}
